import { Link } from "react-router-dom";
import IniciaisLetras from "./iniciaisLetras";

type cardServicesProps = {
    icone?: string;
    nomeService: string;
    link: string;
    status: boolean | string | number;
}

export default function CardServices({ icone, nomeService, link, status }: cardServicesProps) {
    const isActive = status === true || status === 1 || status === 'true' || status === '1';

    return (
        <Link
            to={isActive ? link : '#'}
            aria-disabled={!isActive}
            className={[
                'tw-flex tw-flex-col tw-items-center tw-justify-center tw-text-center',
                'tw-w-[16%] tw-min-w-[220px] tw-h-[160px]',
                'tw-border tw-border-solid tw-rounded-[10px] ',
                'tw-no-underline tw-text-inherit',
                'tw-transition-all tw-duration-500',
                isActive
                    ? 'tw-border-[#85287e] hover:tw-bg-[#85287d8a] hover:tw-scale-110 hover:tw-border-black tw-cursor-pointer'
                    : 'tw-border-gray-300 tw-opacity-60 tw-pointer-events-none tw-cursor-not-allowed ', //tw-grayscale
            ].join(' ')}
        >
            {icone ? (
                <div className="tw-h-[50px] tw-flex tw-items-center tw-justify-center">
                    <img src={icone} alt={nomeService} className="tw-h-[75px] tw-mx-auto tw-object-contain" />
                </div>
            ) : (
                <span className="tw-text-gray-500 tw-text-2xl">
                    <IniciaisLetras frase={nomeService} />
                </span>
            )}

            <p className="tw-text-[14px] tw-text-gray-800 tw-mt-2 tw-px-2 tw-leading-snug">
                {nomeService}
            </p>
        </Link>
    );
}
